import React, { useState, useRef, useEffect, useMemo } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import "../../css/herosection.css";
import { FaSearch } from "react-icons/fa";
import axios from "axios";
import b11 from '../../images/view-city-square.jpg'
import localityData from '../../assets/tableConvert.com_7uzcb7.json'
import Select from "react-select";
import { FaMapMarkerAlt, FaUserTie, FaBuilding } from "react-icons/fa";
import useDebounc from "./useDebounc";

export const Herosection = () => {
  const [filters, setFilters] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [activeTab, setActiveTab] = useState("New Project");
  const [propertyCategory, setPropertyCategory] = useState("Residential");
  const [selectedPropertyTypes, setSelectedPropertyTypes] = useState([]);
  const [showPropertyOptions, setShowPropertyOptions] = useState(false);
  const buttonRefs = useRef([]);
  const [indicatorStyle, setIndicatorStyle] = useState({});
  const [showSearchBox, setShowSearchBox] = useState(true);
  const [filteredLocalities, setFilteredLocalities] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isLocalityOpen, setIsLocalityOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounc(searchTerm, 300);
  const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const [builderOptions, setBuilderOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);


  const residentialOptions = ["Apartment", "Villa", "Plot", "Independent Floor"];
  const commercialOptions = [
    "Office Space",
    "Shop/Showroom",
    "Commercial Land",
    "Coworking Space",
    "Warehouse",
    "Godown",
    "Industrial Shed",
  ];

 useEffect(() => {
    console.log("Rendering Herosection1");
    axios.get("/api/builders")
      .then((res) => {
        const options = res.data.map((builder) => {
          const label = builder.builder;
          return {
            type: "Builder",
            label: label,
            displayLabel: (
              <div style={{ display: "flex", alignItems: "center" }}>
                <FaUserTie style={{ marginRight: 8, color: "#bba450" }} />
                {label}
                <span style={{ marginLeft: 4, color: "#777", fontWeight: "normal" }}>
                  (Builder)
                </span>
              </div>
            ),
            searchLabel: label.toLowerCase()
          };
        });

        setBuilderOptions(options);
      });
  }, []);

 useEffect(() => {
    console.log("Rendering Herosection2");
    axios.get("/api/projects")
      .then((res) => {
        const builderLabels = new Set(builderOptions.map(opt => opt.label.toLowerCase()));

        const options = res.data.map((project) => {
          const label = project.bpn;
          return {
            type: "Project",
            label: label,
            displayLabel: (
              <div style={{ display: "flex", alignItems: "center" }}>
                <FaBuilding style={{ marginRight: 8, color: "#bba450" }} />
                {label}
                <span style={{ marginLeft: 4, color: "#777", fontWeight: "normal" }}>
                  (Project)
                </span>
              </div>
            ),
            searchLabel: label.toLowerCase()
          };
        }).filter(opt => !builderLabels.has(opt.label.toLowerCase()));

        setProjectOptions(options);
      });
  }, [builderOptions]);


  const togglePropertyType = (property) => {
    setSelectedPropertyTypes((prev) =>
      prev.includes(property) ? prev.filter((item) => item !== property) : [...prev, property]
    );
  };

  useEffect(() => {
    console.log("Rendering Herosection3");
    if (searchTerm.trim() === "") {
      setSelectedSuggestion(null);
    }
  }, [searchTerm]);

  const navigate = useNavigate();

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    setSelectedPropertyTypes([]);
    setShowPropertyOptions(false); // Close the property type dropdown when changing tabs

    setPropertyCategory(tab === "Commercial" ? "Commercial" : "Residential");

    let listingType = "";
    let propertyType = "";

    if (tab === "New Project") {
      listingType = "Resale";
    } else if (tab === "Rent") {
      listingType = "Rent";
    } else if (tab === "Commercial") {
      propertyType = "Commercial";
    } else if (tab === "PG/Coliving") {
      listingType = "PG-Co Living";
      propertyType = "Residential";
    }

    setFilters((prevFilters) => ({
      ...prevFilters,
      listingType,
      propertyType,
    }));
  };

  const closeTypeOptions = () => {
    setShowPropertyOptions(false);
  };

    const handleSearch = () => {
    const queryParams = new URLSearchParams();

    if (searchQuery.trim()) queryParams.set("locality", searchQuery);
    queryParams.set("propertyType", propertyCategory);

   if (activeTab === "Resale") {
    queryParams.set("listingType", "Resale");

    if (selectedPropertyTypes.length > 0) {
      queryParams.set("proptypename", selectedPropertyTypes.join(","));
    }

    let builder = "";
    let locality = "";
    let project = "";

    if (selectedSuggestion) {
      if (selectedSuggestion.type === "Builder") {
        builder = selectedSuggestion.label;
      } else if (selectedSuggestion.type === "Locality") {
        locality = selectedSuggestion.label;
      } else if (selectedSuggestion.type === "Project") {
        project = selectedSuggestion.label;
      }
    } else {
      locality = searchTerm.trim();
    }

    if (builder) queryParams.set("builder", builder);
    if (locality) queryParams.set("locality", locality);
    if (project) queryParams.set("project", project);

    navigate(`/search?${queryParams.toString()}`);
  }

    else if (activeTab === "Rent") {
      queryParams.set("listingType", "Rent");
      if (selectedPropertyTypes.length > 0) {
        queryParams.set("proptypename", selectedPropertyTypes.join(","));
      }
      navigate(`/search?${queryParams.toString()}`);
    }

    else if (activeTab === "Commercial") {
      queryParams.set("propertyType", "Commercial");
      queryParams.set("listingType", "Resale");
      if (selectedPropertyTypes.length > 0) {
        queryParams.set("proptypename", selectedPropertyTypes.join(","));
      }
      navigate(`/search?${queryParams.toString()}`); // ✅ add this
    }

    else if (activeTab === "PG Coliving") {
      queryParams.set("listingType", "PG/Co-living");
      queryParams.set("propertyType", "Residential");
      if (selectedPropertyTypes.length > 0) {
        queryParams.set("proptypename", selectedPropertyTypes.join(","));
      }
      navigate(`/search?${queryParams.toString()}`);
    }

    else if (activeTab === "New Project") {
      let builder = "";
      let project = "";
      let locality = "";

      if (selectedSuggestion) {
        if (selectedSuggestion.type === "Builder") {
          builder = selectedSuggestion.label;
        } else if (selectedSuggestion.type === "Project") {
          project = selectedSuggestion.label;
        } else if (selectedSuggestion.type === "Locality") {
          locality = selectedSuggestion.label;
        }
      } else {
        locality = searchTerm.trim();
      }

      const newProjectQuery = new URLSearchParams();
      newProjectQuery.set("type", propertyCategory);
      newProjectQuery.set("propertytype", selectedPropertyTypes.join(","));
      if (builder) newProjectQuery.set("builder", builder);
      if (project) newProjectQuery.set("project", project);
      if (locality) newProjectQuery.set("locality", locality);

      navigate(`/new-search-projects?${newProjectQuery.toString()}`);
    } else {
      navigate(`/search?${queryParams.toString()}`);
    }

  };


  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  useEffect(() => {
    const index = ["New Project", "Commercial", "Resale", "PG Coliving"].indexOf(activeTab);
    const currentBtn = buttonRefs.current[index];
    if (currentBtn) {
      setIndicatorStyle({
        width: `${currentBtn.offsetWidth}px`,
        transform: `translateX(${currentBtn.offsetLeft}px)`,
      });
    }
  }, [activeTab]);


  const localityOptions = useMemo(() => {
    return localityData.map((loc) => {
      const localityName = loc["Chennai"];
      return {
        type: "Locality",
        label: localityName,
        displayLabel: (
          <div style={{ display: "flex", alignItems: "center" }}>
            <FaMapMarkerAlt style={{ marginRight: 8, color: "#bba450" }} />
            {localityName}
            <span style={{ marginLeft: 4, color: "#777", fontWeight: "normal" }}>
              (Chennai)
            </span>
          </div>
        ),
        searchLabel: localityName.toLowerCase(),
      };
    });
  }, [localityData]);

  const options = useMemo(() => {
    return localityData.map((item) => ({
      value: item.Chennai,
      label: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <FaMapMarkerAlt style={{ marginRight: 8, color: "#bba450" }} />
          {item.Chennai}
          <span style={{ marginLeft: 4, color: "#777", fontWeight: "normal" }}>
            ({item.district || "Chennai"})
          </span>
        </div>
      ),
    }));
  }, [localityData]);

const customStyles = {
  control: (provided) => ({
    ...provided,
    padding: "6px 10px",
    borderRadius: 10,
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    border: "1px solid #ddd",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 1000,
    borderRadius: 10,
    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
    backgroundColor: "#fff",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f5f5f5" : "#fff",
    color: "#333",
    padding: 10,
    fontSize: 14,
    cursor: "pointer",
  }),
  singleValue: (provided) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
  }),
};



  const allOptions1 = useMemo(() => [...builderOptions, ...projectOptions, ...localityOptions], [builderOptions, projectOptions, localityOptions]);
  const allOptions2 = useMemo(() => [ ...localityOptions], [localityOptions]);

  useEffect(() => {
    console.log("builderOptions changed:", builderOptions);
  }, [builderOptions]);

  useEffect(() => {
    console.log("projectOptions changed:", projectOptions);
  }, [projectOptions]);

  useEffect(() => {
    console.log("localityOptions changed");
  }, [localityOptions]);

  useEffect(() => {
    console.log("activeTab changed:", activeTab);
  }, [activeTab]);

const currentOptions = useMemo(() => {
    return activeTab === "New Project" ? allOptions1 : allOptions2;
  }, [activeTab, allOptions1, allOptions2]);

  useEffect(() => {
    console.log("Rendering Herosection5");

    // ✅ Move this logic into a function to keep useEffect clean
    const updateSuggestions = () => {
      if (debouncedSearchTerm.trim()) {
        const filtered = currentOptions.filter(item =>
          item.searchLabel?.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
        );
        setFilteredSuggestions(filtered);
        setShowSuggestions(true);
      } else {
        setFilteredSuggestions([]);
        setShowSuggestions(false);
      }
    };

    updateSuggestions();
  }, [debouncedSearchTerm, currentOptions]);


  return (
    <div className="new-hero">
      <div className="new-hero-banner">
        <Slider {...settings}>
          <div><img src={b11} alt="Real Estate" /></div>
          <div><img src={b11} alt="Real Estate" /></div>
          <div><img src={b11} alt="Real Estate" /></div>
        </Slider>
        <div className="overlay"></div>
      </div>
      <div className="new-search-section">
        <div className="new-hero-overlay">
          {/* <h3 className="cursor typewriter-animation">Find Your Dream Home with 0% Brokerage 
      </h3> */}
          <h1>Find Your Dream Home with 0% Brokerage </h1>
          <span> Chennai’s Most Trusted Property Partner</span>
        </div>
        <div className="new-search-tabs">
          <div className="tab-buttons-wrapper">
            {["New Project", "Commercial", "Resale", "PG Coliving"].map((tab, index) => (
              <button
                key={tab}
                ref={(el) => (buttonRefs.current[index] = el)}
                className={`tab-btn ${activeTab === tab ? "new-active-tab" : ""}`}
                onClick={() => handleTabClick(tab)}
              >
                {tab}
              </button>
            ))}
            <div className="tab-indicator" style={indicatorStyle}></div>
          </div>
        </div>

        {activeTab !== "PG Coliving" && showSearchBox && (
          <div className="new-search-filters">
            <div className="btn-type">
              {activeTab !== "Commercial" && (
                <div className="select-wrapper">
                <select
                  value={propertyCategory}
                  onChange={(e) => {
                    setPropertyCategory(e.target.value);
                    setSelectedPropertyTypes([]);
                    closeTypeOptions(); // Close dropdown when selecting property type
                  }}
                  className="property-dropdown"
                >
                  <option value="Residential">Residential</option>
                  <option value="Commercial">Commercial</option>
                </select>
                </div>
              )}

              <button className={activeTab === "Commercial" ? "toggle-options-btn-comm" :"toggle-options-btn"} onClick={() => setShowPropertyOptions(!showPropertyOptions)}>
                {showPropertyOptions ? "Hide Types" : "+ Select Type"}
              </button>
            </div>

            {showPropertyOptions && (
              <div className="property-options">
                {(propertyCategory === "Residential" ? residentialOptions : commercialOptions).map((type) => (
                  <label key={type} className="property-checkbox">
                    <input
                      type="checkbox"
                      checked={selectedPropertyTypes.includes(type)}
                      onChange={() => togglePropertyType(type)}
                    />
                    {type}
                  </label>
                ))}
              </div>
            )}
            <div className="flex1">

                {(activeTab === "New Project" || activeTab === "Commercial") && (
                <>
                  <input
                    type="text"
                    placeholder={
                      activeTab === "New Project"
                        ? "Search Builder / Project / Locality"
                        : "Search Project / Locality"
                    }
                    value={searchTerm}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchTerm(value);
                      setSelectedSuggestion(null);

                      const optionsToFilter =
                        activeTab === "New Project" ? allOptions1 : allOptions2;


                      if (value.trim().length > 0) {
                        setFilteredSuggestions(
                          optionsToFilter.filter(item =>
                            item.searchLabel.includes(value.toLowerCase())
                          )
                        );
                        setShowSuggestions(true);
                      } else {
                        setFilteredSuggestions([]);
                        setShowSuggestions(false);
                      }
                    }}
                    onFocus={() => setShowSuggestions(true)}
                    onBlur={() => {
                      setTimeout(() => {
                        setShowSuggestions(false);
                      }, 100); // Allows time for list item click to register
                    }}
                    className={
                      activeTab === "Commercial"
                        ? "input-text-comm"
                        : "w-full px-4 py-3 text-sm border-none rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#bba450]"
                    }
                  />

                  {showSuggestions && filteredSuggestions.length > 0 && (
                    <ul
                      className={
                        activeTab === "Commercial"
                          ? "dropdown-locality-list-comm mt-2"
                          : "dropdown-locality-list mt-2"
                      }
                    >
                      {filteredSuggestions.map((item, idx) => (
                        <li
                          key={idx}
                          className="dropdown-locality-item"
                          onMouseDown={() => {
                            setSearchTerm(item.label);
                            setSelectedSuggestion(item);
                            setShowSuggestions(false);
                          }}
                        >
                          {item.type === "Locality" && (
                            <FaMapMarkerAlt className="min-w-[16px] h-[16px]" color="#bba450" />
                          )}
                          {item.type === "Builder" && (
                            <FaUserTie className="min-w-[16px] h-[16px]" color="#bba450" />
                          )}
                          {item.type === "Project" && (
                            <FaBuilding className="min-w-[16px] h-[16px]" color="#bba450" />
                          )}
                          <span className="ml-2">
                            {item.label}
                            <span className="location ml-1">({item.type})</span>
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              )}



              {/* ____________________________________________________ */}


              {(activeTab === "Resale") && (
                <>
                  <input
                    type="text"
                    placeholder={
                      activeTab === "New Project"
                        ? "Search Builder / Project / Locality"
                        : "Search Project / Locality"
                    }
                    value={searchTerm}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSearchTerm(value);
                      setSelectedSuggestion(null);

                      const optionsToFilter =
                        activeTab === "New Project" ? allOptions1 : allOptions2;


                      if (value.trim().length > 0) {
                        setFilteredSuggestions(
                          optionsToFilter.filter(item =>
                            item.searchLabel.includes(value.toLowerCase())
                          )
                        );
                        setShowSuggestions(true);
                      } else {
                        setFilteredSuggestions([]);
                        setShowSuggestions(false);
                      }
                    }}
                    onFocus={() => setShowSuggestions(true)}
                    onBlur={() => {
                      setTimeout(() => {
                        setShowSuggestions(false);
                      }, 100); // Allows time for list item click to register
                    }}
                    className={
                      activeTab === "Commercial"
                        ? "input-text-comm"
                        : "w-full px-4 py-3 text-sm border-none rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#bba450]"
                    }
                  />

                  {showSuggestions && filteredSuggestions.length > 0 && (
                    <ul
                      className={
                        activeTab === "Commercial"
                          ? "dropdown-locality-list-comm mt-2"
                          : "dropdown-locality-list mt-2"
                      }
                    >
                      {filteredSuggestions.map((item, idx) => (
                        <li
                          key={idx}
                          className="dropdown-locality-item"
                          onMouseDown={() => {
                            setSearchTerm(item.label);
                            setSelectedSuggestion(item);
                            setShowSuggestions(false);
                          }}
                        >
                          {item.type === "Locality" && (
                            <FaMapMarkerAlt className="min-w-[16px] h-[16px]" color="#bba450" />
                          )}
                          {item.type === "Builder" && (
                            <FaUserTie className="min-w-[16px] h-[16px]" color="#bba450" />
                          )}
                          {item.type === "Project" && (
                            <FaBuilding className="min-w-[16px] h-[16px]" color="#bba450" />
                          )}
                          <span className="ml-2">
                            {item.label}
                            <span className="location ml-1">({item.type})</span>
                          </span>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              )}


            <button onClick={handleSearch}>Search</button>
          </div>
          </div>
        )}
        {activeTab === "PG Coliving" && (
          <div className="pg">
            <div className="new-search-filters">
              <div className="flex1">
               <input
              type="text"
              placeholder="Enter Locality, Landmark, or Project..."
              value={searchQuery}
              className="w-full px-4 py-3 text-sm border-none rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#bba450]"
              onChange={(e) => {
                const value = e.target.value;
                setSearchQuery(value);

                if (value.trim().length > 0 && localityData.length > 0) {
                  const results = localityData.filter((item) =>
                    item.Chennai.toLowerCase().includes(value.toLowerCase())
                  );
                  setFilteredLocalities(results);
                  setShowDropdown(true);
                } else {
                  setFilteredLocalities([]);
                  setShowDropdown(false);
                }
              }}
              onFocus={closeTypeOptions}
            />

            {showDropdown && filteredLocalities.length > 0 && (
             <ul className={activeTab === "PG Coliving" ? "dropdown-locality-list-pg mt-2" : "dropdown-locality-list mt-2"}>
                {filteredLocalities.map((item, index) => (
                  <li
                    key={index}
                    className="dropdown-locality-item"
                    onClick={() => {
                      setSearchQuery(item.Chennai);
                      setShowDropdown(false);
                    }}
                  >
                    <svg
                      className="min-w-[16px] h-[16px]"
                      fill="#bba450"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5z" />
                    </svg>
                    <span className="ml-2">
                      {item.Chennai}
                      <span className="location ml-1">
                        ({item.district || "Chennai"})
                      </span>
                    </span>
                  </li>
                ))}
              </ul>
            )}
              <button onClick={handleSearch}>Search</button>
            </div>
            </div>
          </div>
        )}
      </div>
    </div>

  );
};

